/*
 * @Description:
 * @Date: 2020-07-19 15:20:21
 */
import { BI } from '@/api/ajax';
import { percentage } from '@/tools/index';
import { createBarSeries } from '../components/Echarts/echartOption';
import { dealTips } from '../tools/index';

export default {
  queryAllianceUserInfo() {
    return new Promise(async resolve => {
      let {
        data: {
          data: { illegalCount, ...counts }
        }
      } = await BI[this.query.serviceType].queryAllianceUserInfo(this.query);
      let map = {
        ageRange1Count: '18~30周岁',
        ageRange2Count: '31~40周岁',
        ageRange3Count: '41~50周岁',
        ageRange4Count: '51~70周岁',
        ageRange5Count: '70周岁以上',
        boyCount: '男性',
        girlCount: '女性'
      };
      let respCount = counts.boyCount + counts.girlCount;
      let ageSeries0data = [];
      let genderSeries0data = [];
      Object.entries(counts).forEach((m, i) => {
        if (['girlCount', 'boyCount'].includes(m[0])) {
          genderSeries0data.push({
            value: m[1],
            name: map[m[0]] + `:${percentage(m[1], respCount)}%`
          });
        } else {
          ageSeries0data.push({
            value: m[1],
            name: map[m[0]] + `:${percentage(m[1], respCount)}%`
          });
        }
      });
      const newAgeSeries0data = [];

      const ageSeries0dataTotal = ageSeries0data.reduce((pre, cur) => {
        pre += cur.value || 0;
        return pre;
      }, 0);
      for (let i = 0; i < ageSeries0data.length; i++) {
        newAgeSeries0data.push({
          ...ageSeries0data[i],
          index: i,
          itemStyle: {
            normal: {
              color: [
                '#2722FF',
                '#6764FF',
                '#CFCEFF',
                '#5fc5ff',
                '#EBB81B',
                'rgba(0,0,0,0)'
              ][i]
            }
          }
        });
        if (ageSeries0data[i + 1] && (ageSeries0data[i + 1] || {}).value > 0) {
          // 下一项存在，并且大于0
          newAgeSeries0data.push({
            value: ageSeries0dataTotal / 30,
            name: '',
            itemStyle: {
              normal: {
                color: 'rgba(0, 0, 0, 0)',
                borderColor: 'rgba(0, 0, 0, 0)',
                borderWidth: 0
              }
            }
          });
        }
      }
      newAgeSeries0data.push({
        value: newAgeSeries0data.reduce((pre, cur) => {
          pre += cur.value || 0;
          return pre;
        }, 0),
        name: '',
        itemStyle: {
          normal: {
            color: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0
          }
        }
      });
      resolve([
        {
          key: 'age',
          value: {
            echart: [
              {
                echartType: 'pie',
                echartOption: {
                  series: [
                    {
                      type: 'pie',
                      silent: true,
                      hoverAnimation: false,
                      startAngle: -360,
                      radius: ['62%', '65%'],
                      center: ['50%', '50%'],
                      label: {
                        normal: {
                          show: false,
                          position: 'inner'
                        }
                      },
                      data: newAgeSeries0data.reduce((pre, cur, index) => {
                        pre.push({
                          ...cur,
                          itemStyle: {
                            normal: {
                              ...cur.itemStyle.normal,
                              color:
                                newAgeSeries0data.length == index + 1
                                  ? 'rgba(231, 230, 255, .8)'
                                  : 'rgba(0, 0, 0, 0)'
                            }
                          }
                        });
                        return pre;
                      }, [])
                    },
                    {
                      type: 'pie',
                      silent: true,
                      hoverAnimation: false,
                      startAngle: -180,
                      radius: ['70%', '100%'],
                      center: ['50%', '50%'],
                      label: {
                        normal: {
                          show: false,
                          position: 'inner'
                        }
                      },
                      data: newAgeSeries0data.reduce((pre, cur) => {
                        pre.push({
                          ...cur,
                          itemStyle: {
                            normal: {
                              ...cur.itemStyle.normal,
                              opacity: 0.5
                            }
                          }
                        });
                        return pre;
                      }, [])
                    },
                    {
                      type: 'pie',
                      hoverAnimation: false,
                      startAngle: -180,
                      radius: ['73%', '100%'],
                      center: ['50%', '50%'],
                      label: {
                        normal: {
                          show: true,
                          position: 'inner',
                          formatter: params => {
                            return params.data.value > 0 && params.data.name
                              ? `${params.data.index + 1}`.padStart(2, 0)
                              : '';
                          }
                        }
                      },
                      data: newAgeSeries0data
                    }
                  ]
                },
                echartStyle: {
                  width: '220px',
                  height: '220px'
                }
              }
            ]
          }
        },
        {
          key: 'gender',
          value: {
            data: genderSeries0data,
            echart: [
              {
                echartType: 'pie',
                echartOption: {
                  series: [{ radius: '70%', data: genderSeries0data }]
                },
                echartStyle: {
                  width: '550px',
                  height: '400px'
                }
              }
            ]
          }
        }
      ]);
    });
  },
  // 审核状态
  querytaskStatusTotalInfo() {
    return new Promise(async resolve => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].querytaskStatusTotalInfo(this.query);
      let {
        dataCount,
        finalDataCount,
        projectId,
        taskDt,
        ...audits
      } = resp || {
        finalDataCount: 0,
        auditStatus1: 0,
        auditStatus2: 0,
        auditStatus3: 0,
        auditStatus4: 0
      };
      // 不展示 审核中
      delete audits.auditStatus1;
      let respCount = dataCount || finalDataCount;
      let map = {
        auditStatus1: '审核中',
        auditStatus2: '审核通过',
        auditStatus3: '审核未通过',
        auditStatus4: '任务失效'
      };
      let header = [
        { label: '状态', prop: 'd' },
        { label: '数量', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let data = [];
      let series0data = [];
      Object.entries(audits).forEach(item => {
        series0data.push({
          value: item[1],
          name: map[item[0]] + `:${item[1]}`
        });
        data.push({
          d: map[item[0]],
          v: item[1],
          b: percentage(item[1], respCount) + '%'
        });
      });
      resolve({
        key: 'audit',
        value: {
          data: series0data,
          total: series0data.reduce((pre, cur) => {
            pre += cur.value || 0;
            return pre;
          }, 0),
          table: { header, data, finalDataCount: respCount },
          echart: [
            {
              echartType: 'pie',
              echartOption: {
                series: [{ radius: ['43%', '70%'], data: series0data }]
              },
              echartStyle: {
                width: '550px',
                height: '400px'
              }
            }
          ]
        }
      });
    });
  },
  // 执行任务列表
  queryTaskSumTotalInfo() {
    return new Promise(async resolve => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].queryTaskSumTotalInfo(this.query);
      resp = resp || { finalDataCount: 0, finalData: {} };
      let { dataCount, finalDataCount, finalData } = resp;
      let respCount = dataCount || finalDataCount;

      let map = {
        taskSum1Count: '0-20',
        taskSum2Count: '21-40',
        taskSum3Count: '41-60',
        taskSum4Count: '61-80',
        taskSum5Count: '81-100',
        taskSum6Count: '100以上'
      };
      let header = [
        { label: '任务数（单）', prop: 'd' },
        { label: '执行人数（人）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let data = [];
      let xAxisData = [];
      let series0data = [];
      finalData.forEach(item => {
        let [m] = Object.entries(item);
        xAxisData.push(m[0]);
        series0data.push(m[1]);
        data.push({
          d: m[0],
          v: m[1],
          b: percentage(m[1], respCount) + '%'
        });
      });
      resolve({
        key: 'implement',
        value: {
          table: { header, data, finalDataCount: respCount },
          echart: [
            {
              echartType: 'bar',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '人');
                  }
                },
                xAxis: {
                  name: '人'
                },
                yAxis: {
                  name: '任务数（单）',
                  data: xAxisData
                },
                series: createBarSeries(series0data)
              }
            }
          ]
        }
      });
    });
  }
};
